import Vue from 'vue'
import Router from 'vue-router'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import HelloWorld from '@/components/HelloWorld'
import article from '@/components/article'
import referals from '@/components/referals'
import news from '@/components/news'
import pay from '@/components/pay'
import who from '@/components/who'
import how from '@/components/how'
// import win from '@/components/win'
import all from '@/components/table'
import smartGroup from '@/components/smartGroup'
import uristGroup from '@/components/uristGroup'
import uristProgram from '@/components/uristProgram'
import smartProgram from '@/components/smartProgram'
import free from '@/components/free'
import subscription from '@/components/subscription'

Vue.use(Loading)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/referals',
      name: 'referals',
      component: referals
    },
    {
      path: '/referal/:id',
      name: 'referal',
      component: HelloWorld
    },
    {
      path: '/news/:id',
      name: 'news',
      component: news
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/who-needs',
      name: 'who',
      component: who
    },
    {
      path: '/how-it-works',
      name: 'how',
      component: how
    },
    {
      path: '/free',
      name: 'free',
      component: free
    },
    {
      path: '/all',
      name: 'all',
      component: all
    },
    {
      path: '/smart/group/:id',
      name: 'smartGroup',
      component: smartGroup
    },
    {
      path: '/smart/program/:id',
      name: 'smartProgram',
      component: smartProgram
    },
    {
      path: '/urist/group/:id',
      name: 'uristGroup',
      component: uristGroup
    },
    {
      path: '/urist/program/:id',
      name: 'uristProgram',
      component: uristProgram
    },
    {
      path: '/subscription',
      name: 'subscription',
      component: subscription
    },
    {
      path: '*',
      name: 'article',
      component: article
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})
let loader
router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: '#000',
      color: '#FA5663',
      isFullPage: true
    })
  }
  next()
})

router.afterEach((to, from) => {
  loader.hide()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js